module.exports = __webpack_public_path__ + "img/listnonsel.82f93065.svg";